import { Tabs } from 'antd';
import React from 'react';
import { IOALogin } from '@/presentation/pages/login/ioa-login';
import { TencentCloudLogin } from '@/presentation/pages/login/tencent-cloud-login';
import { LoginType } from '@/presentation/pages/login/types';
// import { useIntranet } from '@/presentation/pages/login/use-intranet';
import styles from './index.module.scss';

export interface LoginFormProps {
  onSuccess?: () => void;
}

const { TabPane } = Tabs;

export const LoginForm: React.FC<LoginFormProps> = (props) => {
  const {} = props;
  // 暂时隐藏ioa登录
  // const isIntranet = useIntranet();

  const loginTabs = [
    {
      label: 'iOA账号登录',
      key: LoginType.IOA,
      children: <IOALogin />,
      hidden: true,
    },
    {
      label: '微信账号登录',
      key: LoginType.TencentCloud,
      children: <TencentCloudLogin />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey={LoginType.TencentCloud}
      className={styles.loginTabs}
    >
      {loginTabs.filter(tab => !tab.hidden).map(tab => <TabPane tab={tab.label} key={tab.key}>{tab.children}</TabPane>)}
    </Tabs>
  );
};
